import button, { buttonVariants, type ButtonVariantsType } from './button';
import heading, { headingVariants, type HeadingVariantsType } from './heading';
import item, { itemVariants, type ItemVariantsType } from './item';
import panel, { panelVariants, type PanelVariantsType } from './panel';
import type { Utility } from '../../../types/utility';

const accordion = {
  button,
  heading,
  item,
  panel,
};

export const accordionVariants = {
  button: buttonVariants,
  heading: headingVariants,
  item: itemVariants,
  panel: panelVariants,
};

export type AccordionComponentsType = 'button' | 'heading' | 'item' | 'panel';

export type AccordionType = {
  /** The Accordion subcomponent types. */
  SubComponents: {
    [K in AccordionComponentsType]: Utility.VariantKeyModes<
      K extends 'button'
        ? ButtonVariantsType
        : K extends 'heading'
        ? HeadingVariantsType
        : K extends 'item'
        ? ItemVariantsType
        : K extends 'panel'
        ? PanelVariantsType
        : never
    >;
  };
  /** The Accordion.Button component variant types. */
  Button: Utility.VariantKeys<ButtonVariantsType>;
  /** The Accordion.Heading component variant types. */
  Heading: Utility.VariantKeys<HeadingVariantsType>;
  /** The Accordion.Item component variant types. */
  Item: Utility.VariantKeys<ItemVariantsType>;
  /** The Accordion.Panel component variant types. */
  Panel: Utility.VariantKeys<PanelVariantsType>;
};

export default accordion;
